import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'product-types';

const updateProductTypeById = async (body, productTypeId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${productTypeId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateProductTypeById;
